(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileViewport = window.matchMedia('(max-width: 749px)');

  function initSlider(root) {
    if (root.dataset.fcSliderReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-fc-slide]'));
    const controls = root.querySelector('[data-fc-controls]');
    if (slides.length < 2 || !controls) return;

    const dots = Array.from(controls.querySelectorAll('[data-fc-dot]'));
    const pauseButton = controls.querySelector('[data-fc-pause]');
    const delay = Math.max(0, Number(root.dataset.autoplaySeconds) || 0) * 1000;
    let current = 0;
    let timer;
    let paused = false;
    let hovered = false;
    let focused = false;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        const active = position === current;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === current)));
    }

    function schedule() {
      window.clearTimeout(timer);
      if (!delay || paused || hovered || focused || document.hidden || reducedMotion.matches || mobileViewport.matches) return;
      timer = window.setTimeout(() => {
        show(current + 1);
        schedule();
      }, delay);
    }

    function navigate(index) {
      show(index);
      schedule();
    }

    controls.querySelector('[data-fc-prev]').addEventListener('click', () => navigate(current - 1));
    controls.querySelector('[data-fc-next]').addEventListener('click', () => navigate(current + 1));
    dots.forEach((dot, position) => dot.addEventListener('click', () => navigate(position)));

    let touchStart;
    root.addEventListener('touchstart', (event) => {
      touchStart = mobileViewport.matches && event.touches.length === 1 && !event.target.closest('a, button')
        ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
        : undefined;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      if (!touchStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = undefined;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) navigate(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
    root.addEventListener('touchcancel', () => { touchStart = undefined; }, { passive: true });

    if (pauseButton) {
      pauseButton.addEventListener('click', () => {
        paused = !paused;
        pauseButton.textContent = paused ? 'Play' : 'Pause';
        pauseButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        schedule();
      });
    }

    root.addEventListener('mouseenter', () => { hovered = true; schedule(); });
    root.addEventListener('mouseleave', () => { hovered = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', () => {
      window.setTimeout(() => {
        focused = root.contains(document.activeElement);
        schedule();
      }, 0);
    });

    const onVisibilityChange = () => schedule();
    const onMotionChange = () => {
      if (pauseButton) pauseButton.hidden = reducedMotion.matches || mobileViewport.matches;
      schedule();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    reducedMotion.addEventListener('change', onMotionChange);
    mobileViewport.addEventListener('change', onMotionChange);

    root.fcShowSlide = navigate;
    root.fcDestroySlider = () => {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      reducedMotion.removeEventListener('change', onMotionChange);
      mobileViewport.removeEventListener('change', onMotionChange);
    };
    root.dataset.fcSliderReady = 'true';
    controls.hidden = false;
    onMotionChange();
  }

  function initWithin(scope) {
    scope.querySelectorAll('[data-fc-hero-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document));
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fc-hero-slider]').forEach((root) => root.fcDestroySlider?.());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-fc-slide]');
    const root = slide?.closest('[data-fc-hero-slider]');
    if (!root?.fcShowSlide) return;
    const index = Array.from(root.querySelectorAll('[data-fc-slide]')).indexOf(slide);
    if (index >= 0) root.fcShowSlide(index);
  });
})();

